<template>
  <div class="GlobalTable">
    <GlobalTable
      ref="GlobalTable"
      v-loading="loading"
      :columns="tableColumns"
      :data="this.seachDataList"
      :currentPage="page.pageNum"
      :total="this.page.total"
      @handleCurrentChange="handleCurrentChange"
    >
      <el-table-column
        label="店员编码"
        slot="staffCode"
        align="center"
        v-if="type == '02'"
      >
        <template slot-scope="{ row }">
          <span>{{ row.staffCode || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="职位"
        slot="staffType"
        align="center"
        v-if="type == '02'"
      >
        <template slot-scope="{ row }">
          <span>{{
            row.staffType == "01"
              ? "子账号"
              : row.staffType == "02"
              ? "总监"
              : row.staffType == "03"
              ? "店长"
              : "店员"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="所属门店"
        slot="storeName"
        align="center"
        v-if="type == '02'"
      >
        <template slot-scope="{ row }">
          <span v-if="row.staffType != '02'">{{ row.storeName || "--" }}</span>
          <span
            v-if="row.staffType == '02' && row.storeIds && row.storeIds.length"
            style="
              color: #0981ff;
              cursor: pointer;
              border-bottom: 1px solid rgb(9, 129, 255);
            "
            @click="openStore(row)"
            >{{ row.storeIds.length }}</span
          >
          <span
            v-if="
              row.staffType == '02' &&
                (!row.storeIds || (row.storeIds && !row.storeIds.length))
            "
            >--</span
          >
        </template>
      </el-table-column>
      <!--最近活跃时间-->
      <el-table-column
        label="最近活跃时间"
        slot="lastActiveTime"
        align="center"
      >
        <template slot-scope="{ row }">
          <span>{{ row.lastActiveTime || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="最近下单时间"
        slot="lastCreateOrderTime"
        align="center"
      >
        <template slot-scope="{ row }">
          <span>{{
            row.lastCreateOrderTime ? row.lastCreateOrderTime : "--"
          }}</span>
        </template>
      </el-table-column>

      <el-table-column label="是否关注公众号" slot="isSubscribe" align="center">
        <template slot-scope="{ row }">
          <span :style="row.isSubscribe ? 'color:green' : 'color:red'">{{
            row.isSubscribe ? "是" : "否"
          }}</span>
        </template>
      </el-table-column>
      <!-- 是否可以查看数据 -->
      <!-- <el-table-column
        width="150"
        :render-header="renderHeader"
        slot="canSeeRecycleData"
        align="center"
      >
        <template slot-scope="{ row }">
          <span v-if="!row.canSeeRecycleData && row.staffType != '03'">--</span>
          <el-switch
            inactive-color="#bebebe"
            v-else
            v-model="row.canSeeRecycleData"
            @change="canSeeDatachange($event, row)"
          ></el-switch>
        </template>
      </el-table-column> -->
      <!-- 是否可以为收银员 -->
      <el-table-column
        width="90"
        label="设为收银"
        :render-header="renderHeader2"
        slot="canSeeRecycleData"
        align="center"
      >
        <template slot-scope="{ row }">
          <span v-if="!row.isStoreCashier && row.staffType != '04'">--</span>
          <el-switch
            inactive-color="#bebebe"
            v-else
            v-model="row.isStoreCashier"
            @change="isStoreCachange($event, row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="主从账号管理"
        v-if="isOpenSub"
        slot="subCount"
        align="center"
      >
        <template slot-scope="{ row }">
          <span
            v-if="row.subCount"
            style="
              color: #0981ff;
              cursor: pointer;
              border-bottom: 1px solid rgb(9, 129, 255);
            "
            @click="openSubCount(row)"
            >{{ row.subCount }}</span
          >
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="账号启用/禁用" slot="isEnable" align="center">
        <template slot-scope="{ row }">
          <el-switch
            inactive-color="#bebebe"
            @change="handleSwitch(row, 'switch')"
            v-model="row.isEnable"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="动态口令登录码"
        slot="command"
        align="center"
        v-if="isNeedValid"
      >
        <template slot-scope="{ row }">
          <span
            @click="generate(row)"
            v-if="!row.createMajorGoogleCode"
            style="text-decoration: underline;cursor: pointer; color: rgb(9, 129, 255);"
            >生成</span
          >
          <template v-else>
            <span
              @click="generateSee(row)"
              style="text-decoration: underline;cursor: pointer; color: rgb(9, 129, 255);margin-right:20px"
              >查看</span
            >
            <span
              @click="anewGenerate(row)"
              style="text-decoration: underline;cursor: pointer; color: #FF687B;"
              >重新生成</span
            >
          </template>
        </template>
      </el-table-column>
      <el-table-column
        label="店员离职"
        slot="state"
        align="center"
        v-if="type == '02'"
      >
        <template slot-scope="{ row }">
          <el-button
            size="mini"
            type="primary"
            v-if="!row.isQuit"
            round
            @click="handleBtn(row, 'quit')"
            >店员离职</el-button
          >
          <el-button size="mini" type="info" v-else round>已离职</el-button>
        </template>
      </el-table-column>
      <el-table-column width="250" label="操作" slot="operation" align="center">
        <template slot-scope="{ row }">
          <el-button
            v-if="!row.isQuit"
            size="mini"
            type="primary"
            round
            :disabled="row.isQuit && type == '02'"
            @click="handleBtn(row, 'edit')"
            >编辑</el-button
          >
          <el-button
            v-if="
              row.isQuit && (row.staffType == '03' || row.staffType == '04')
            "
            size="mini"
            type="primary"
            round
            @click="handleBtn(row, 'recovery')"
            >复职</el-button
          >
          <el-button
            size="mini"
            type="danger"
            round
            @click="handleBtn(row, 'reset')"
            v-if="type == '01'"
            >重置密码</el-button
          >
          <el-button
            size="mini"
            type="danger"
            round
            @click="handleBtn(row, 'del')"
            v-if="type == '02'"
            >删除</el-button
          >
          <el-button
            size="mini"
            type="success"
            :disabled="row.staffType == '01' || row.staffType == '02'"
            round
            @click="handleBtn(row, 'allot')"
            v-if="type == '02'"
            >员工调拨</el-button
          >
        </template>
      </el-table-column>
    </GlobalTable>
    <!--弹框-->
    <el-dialog
      class="edit-dialog"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :width="dialongDecide != 'edit' ? '440px' : '600px'"
      @closed="handleDialogClosed"
    >
      <div
        v-if="dialongDecide == 'recovery'"
        style="font-size: 16px; color: #666666; height: 100px"
      >
        <div class="step-title">
          <img
            src="@/assets/images/ico_ts_red.png"
            alt=""
            style="width: 18px; height: 18px; margin-right: 5px"
          />
          <span>复职后，职员岗位不变，仍可查看原来订单。</span>
        </div>
        <div style="text-align: center">
          是否确认复职<span style="color: #80c269">{{ recoveryName }}</span
          >？
        </div>
      </div>
      <div
        v-else-if="dialongDecide != 'edit'"
        style="
          font-size: 16px;
          color: #666666;
          text-align: center;
          height: 100px;
          line-height: 100px;
        "
      >
        {{
          dialongDecide == "reset"
            ? "重置后密码默认为用户手机号，是否确认重置用户密码？"
            : "确认要执行该操作吗？"
        }}
      </div>
      <el-form
        ref="form"
        :model="staffForm"
        v-else
        :rules="dialogRules"
        label-width="100px"
      >
        <el-form-item label="职员姓名" prop="staffName">
          <el-input
            placeholder="输入职员姓名（10字内）"
            v-model="staffForm.staffName"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item label="员工编码" prop="staffCode" v-if="type == '02'">
          <el-input
            placeholder="请输入员工编码，如员工erp编码"
            v-model="staffForm.staffCode"
            maxlength="30"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="staffMobile" v-if="type == '01'">
          <el-input
            placeholder="输入职员电话号码（11位）"
            v-model="staffForm.staffMobile"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item label="职员角色" prop="roleId" v-if="type == '01'">
          <el-select
            v-model="staffForm.roleId"
            placeholder="请选择角色"
            disabled
          >
            <el-option
              v-for="ele in byRoleList"
              :key="ele.id"
              :label="ele.roleName"
              :value="ele.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="roleNo == '02' ? '总监' : '子账号'"
          prop="xcxStaffId"
          v-if="(roleNo == '02' || roleNo == '01') && type == '01'"
        >
          <el-select
            v-model="staffForm.xcxStaffId"
            placeholder="请选择"
            :no-data-text="
              roleNo == '02'
                ? '请先添加总监的小程序账号'
                : '请先添加子账号的小程序账号'
            "
          >
            <el-option
              v-for="ele in xcxStaffList"
              :key="ele.staffId"
              :label="ele.staffName"
              :value="ele.staffId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="登录账号"
          prop="userAcc"
          class="acc"
          v-if="type == '01'"
        >
          <el-input
            v-model="staffForm.userAcc"
            :disabled="!canUpdateAcc"
            placeholder="输入登录账号（6-16位字母数字）"
          ></el-input>
          <div style="float: right; color: #ff687b; font-size: 14px">
            {{ canUpdateAcc ? "账号仅可修改一次" : "账号不可修改" }}
          </div>
        </el-form-item>
        <el-form-item label="职员职位" prop="staffType" v-if="type == '02'">
          <el-input
            v-model="staffForm.staffType"
            disabled
            v-if="staffForm.staffTypes == '01' || staffForm.staffTypes == '02'"
          ></el-input>
          <el-select
            v-model="staffForm.staffTypes"
            placeholder="请选择职员职位"
            v-else
          >
            <el-option
              v-for="ele in staffTypeList"
              :key="ele.key"
              :label="ele.value"
              :value="ele.key"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="管辖区域"
          v-if="type == '02' && staffForm.staffType == '总监'"
        >
          <el-select
            v-model="staffForm.areaId"
            clearable
            placeholder="请选择区域"
            filterable
          >
            <el-option
              v-for="ele in Regionaldata"
              :key="ele.id"
              :label="ele.name"
              :value="ele.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="管辖门店"
          prop="storeIds"
          v-if="type == '02' && staffForm.staffType == '总监'"
        >
          <el-select
            v-model="staffForm.storeIds"
            clearable
            placeholder="请选择门店"
            multiple
            @remove-tag="removetag"
            filterable
          >
            <el-option
              label="全部选择"
              :value="allchagestoreIds"
              @click.native="chagestoreIds(staffForm.storeIds)"
            ></el-option>
            <el-option
              v-for="ele in storeList"
              :key="ele.key"
              :label="ele.value"
              :value="ele.key"
              @click.native="chagestoreIdall(staffForm.storeIds)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="所属门店"
          prop="storeIds"
          v-if="
            type == '02' &&
              staffForm.staffType != '总监' &&
              staffForm.staffType != '子账号'
          "
        >
          <el-select
            v-model="staffForm.storeIds"
            placeholder="请选择门店"
            disabled
          >
            <el-option
              v-for="ele in storeList"
              :key="ele.key"
              :label="ele.value"
              :value="ele.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="登录手机号" prop="staffMobile" v-if="type == '02'">
          <el-input
            placeholder="输入职员电话号码（11位）"
            v-model="staffForm.staffMobile"
            clearable
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="handleClose">取消</el-button>
        <el-button type="primary" @click.native="handleSuccess">确定</el-button>
      </span>
    </el-dialog>
    <DialogTbale
      @onClose="storeClose"
      :loading="storeLoading"
      :show="storeVisible"
      title="门店列表"
      :columns="storeColumns"
      :data="dialogList"
      :currentPage="storeParams.pageNum"
      :total="storeParams.total"
      :pageSize="10"
      :width="700"
      :maxHeight="'500'"
      @handleCurrentChange="getStoreList"
    >
      <el-table-column label="门店名称" slot="storeName" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.storeName }}</span>
          <el-tag
            v-if="!row.isEnable"
            style="margin-left: 10px"
            size="mini"
            type="info"
            effect="dark"
          >
            已禁用
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="门店地址" slot="storeAddress" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.storeAddress || "--" }}</span>
        </template>
      </el-table-column>
    </DialogTbale>
    <el-dialog
      class="allot-dialog"
      title="员工调拨"
      :visible.sync="allotVisible"
      :close-on-click-modal="false"
      width="550px"
      @closed="allotDialogClosed"
    >
      <div class="step-title">
        <img
          src="@/assets/images/ico_ts_red.png"
          alt=""
          style="width: 18px; height: 18px; margin-right: 5px"
        />
        <span
          >被调拨店员须处理完当前门店订单，员工调拨后业绩统计归属于调拨门店。</span
        >
      </div>
      <div>
        <div class="select-item">
          <span>选择调拨门店：</span>
          <el-select
            style="flex: 1"
            v-model="allotStoreId"
            filterable
            size="small"
            clearable
            placeholder="请选择调拨门店"
          >
            <el-option
              v-for="item in storeAllotList"
              :key="item.id"
              :label="item.storeName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="select-item">
          <span>选择调拨职位：</span>
          <el-select
            style="flex: 1"
            v-model="allotType"
            filterable
            size="small"
            clearable
            placeholder="请选择调拨职位"
          >
            <el-option
              v-for="item in allotList"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </div>
        <div class="select-item" style="align-items: flex-start">
          <span>该店员近3个月待处理订单：</span>
          <div>
            共
            <el-link
              v-if="allotNoTodoOrderNum"
              type="danger"
              @click="
                $refs['orderDia'].open({
                  staffId,
                  allotOrderScope,
                  allotOrderStartTime,
                })
              "
              >{{ allotNoTodoOrderNum }}</el-link
            >
            <span v-else>{{ allotNoTodoOrderNum }}</span>
            单
          </div>
        </div>
        <div class="select-item" style="align-items: flex-start">
          <span>是否调拨订单：</span>
          <div>
            <el-radio-group v-model="allotOrderScope">
              <el-radio label="01">不调拨订单</el-radio>
              <el-radio label="02">调拨全部订单</el-radio>
              <el-radio label="03">按时间调拨订单</el-radio>
            </el-radio-group>
            <div style="color: #ff687b; font-size: 12px">
              若不调拨，请通知店员处理完待确认、待支付订单
            </div>
          </div>
        </div>
        <div class="select-item" v-if="allotOrderScope == '03'">
          <span>调拨订单时间：</span>
          <div class="flex" style="flex: 1">
            <el-date-picker
              style="flex: 0.5"
              v-model="allotOrderStartTime"
              align="right"
              type="date"
              size="small"
              placeholder="选择日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="timestamp"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
            <span style="margin: 0 10px"> ~ </span>
            <span style="color: #0981ff">今日</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="allotDialogClosed">取消</el-button>
        <el-button type="primary" @click.native="allotSuccess">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      class="sub-dialog"
      title="主从账号管理"
      :visible.sync="subVisible"
      :close-on-click-modal="false"
      width="850px"
      @closed="subDialogClosed"
    >
      <GlobalTable
        ref="subTable"
        v-loading="subloading"
        :columns="subColumns"
        :maxHeight="500"
        :data="subDataList"
        :isPagination="false"
        :isIndex="true"
      >
        <el-table-column label="账号类型" slot="isStaffSub" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.isStaffSub ? "从账号" : "主账号" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="微信昵称" slot="nickName" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.nickName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="微信头像" slot="headImg" align="center">
          <template slot-scope="{ row }">
            <img
              v-if="row.headImg"
              :src="row.headImg"
              style="width: 70px"
              alt=""
            />
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="账号姓名" slot="staffName" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.staffName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="是否关注公众号"
          slot="isSubscribe"
          align="center"
        >
          <template slot-scope="{ row }">
            <span>{{ row.isSubscribe ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="203"
          label="操作"
          slot="operation"
          align="center"
        >
          <template slot-scope="{ row }">
            <div v-if="row.isStaffSub">
              <el-button
                size="mini"
                type="danger"
                round
                @click="staffSubHandleBtn(row, 'relieve')"
                >解除绑定</el-button
              >
              <el-button
                size="mini"
                type="primary"
                round
                @click="staffSubHandleBtn(row, 'set')"
                >设为主账号</el-button
              >
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
      </GlobalTable>
      <div style="height: 20px"></div>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="subStaffShow"
      :close-on-click-modal="false"
      width="450px"
      @closed="closeSubStaffDialog"
    >
      <div class="deltop1txt">
        说明：{{
          operationType == "relieve"
            ? "解除绑定后，该店员登录时需重新向主账号获取验证码"
            : "设为主账号后，原主账号及其他从账号将强制退出登录，如需登录请重新获取验证码。"
        }}
      </div>
      <div class="delcen2txt">
        {{
          operationType == "relieve" ? "确认解除绑定吗？" : "确定设为主账号吗？"
        }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click.native="closeSubStaffDialog"
          >取消</el-button
        >
        <el-button size="small" type="primary" @click.native="sureSubOperation"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="店员离职"
      :visible.sync="quitShow"
      :close-on-click-modal="false"
      width="500px"
      @closed="quitClosed"
    >
      <div class="enable-tip">
        <div>
          说明：操作人员离职，系统将清除该账号绑定的微信头像、昵称、openID等信息
        </div>
        <div v-if="staffBalance">
          该员工账户还有{{ staffBalance }}元未提现<span v-if="frozenBalance"
            >（其中{{ frozenBalance }}元冻结中）</span
          >，操作离职后店员账户余额将入账公司，由公司统一处理。
        </div>
        <div class="tip-sure">
          是否确认将<span style="color: #ff8080">{{ staffName }}</span
          >离职？
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="quitShow = false">取消</el-button>
        <el-button
          type="primary"
          :loading="quitButLoading"
          @click.native="quitSubmit"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="操作提示"
      :visible.sync="resureshow"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="enable-tip">
        <div>
          说明：该账号为主账号，修改后将自动清除该账号绑定的微信头像、昵称、openID等信息
        </div>
        <div class="tip-sure">是否确认修改手机号？</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="resureshow = false">取消</el-button>
        <el-button
          type="primary"
          :loading="quitButLoading"
          @click.native="reSureSubmit"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <OrderDia ref="orderDia" />
    <!--动态二维码-->
    <el-dialog
      title="动态口令登录码"
      :visible.sync="dlogincodeVisible"
      :close-on-click-modal="false"
      width="480px"
      @closed="dlogincodeVisibleClose"
    >
      <div style="font-size:12px;color:rgb(255, 104, 123);margin-bottom:20px">
        说明：登录码根据人员账号生成，需要下载谷歌验证器-扫码添加
      </div>
      <div style="display: flex;justify-content: center;align-items: center">
        <VueQr
          v-if="allData.googleCodeQrcode"
          logoSrc=""
          :text="allData.googleCodeQrcode"
          :size="150"
          :margin="0"
        ></VueQr>
        <div class="left_fg" style="margin-left: 20px;">
          <p>账号：{{ allData.googleCodeKey }}</p>
          <p>密钥：{{ allData.googleCodeSecret }}</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer stydata">
        <div class="left_fg">
          <p>下载地址：</p>
          <p>
            安卓：<span
              class="copy"
              @click="copy(allData.googleCodeDownloadAndroid)"
              >{{ allData.googleCodeDownloadAndroid }}</span
            >
          </p>
          <p>
            苹果：<span
              class="copy"
              @click="copy(allData.googleCodeDownloadIos)"
              >{{ allData.googleCodeDownloadIos }}</span
            >
          </p>
        </div>
        <el-button type="primary" @click.native="dlogincodeVisible = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="操作提示"
      :visible.sync="entryCodeShow"
      :close-on-click-modal="false"
      width="480px"
    >
      <div class="enable-tip">
        <div>
          说明：重新生成登录码后，该职员将自动退出登录，并绑定新的登录码
        </div>
        <div class="tip-sure">是否确认生成新的登录码？</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="entryCodeShow = false">取消</el-button>
        <el-button type="primary" @click.native="entryCodeSubmit"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MinXinRequest from "@/mixins/request";
import _api from "@/utils/request";
import { formValidateMobile } from "@/utils/form-validate";
import OrderDia from "./dialog/OrderDia.vue";
import VueQr from "vue-qr";

export default {
  components: { OrderDia, VueQr },
  name: "Table",
  mixins: [MinXinRequest],
  props: {
    byRoleList: {
      type: Array,
    },
  },
  data() {
    return {
      resureshow: false,
      storeIdsCopy: null,
      Regionaldata: [],
      canSeeData: true,
      allchagestoreIds: undefined,
      loading: false,
      subloading: false,
      quitShow: false,
      subVisible: false,
      subStaffShow: false,
      seachDataList: [],
      subDataList: [],
      storeList: [],
      storeAllotList: [],
      dialogList: [],
      xcxStaffList: [],
      storeLoading: false,
      storeVisible: false,
      allotVisible: false,
      quitButLoading: false,
      storeParams: {},
      inspectorId: "",
      staffBalance: "",
      frozenBalance: "",
      canCashOutBalance: "",
      StaffEnable: {
        id: "",
        isEnable: "",
        type: "01",
      },
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      pageNum: 1,
      type: "01",
      staffForm: {},
      //弹窗
      dialogVisible: false, // 弹框的出现与否
      dialogTitle: "", // 标题
      dialogWidth: 380,
      dialongDecide: "",
      staffId: "", // 职员ID
      roleNo: "",
      canUpdateAcc: false,
      recoveryName: "",
      roleList: [
        {
          value: "01",
          label: "子账号",
        },
        {
          value: "02",
          label: "总监",
        },
        {
          value: "03",
          label: "店长",
        },
        {
          value: "04",
          label: "店员",
        },
      ],
      tableColumns: [],
      dialogRules: {
        staffName: [
          {
            required: true,
            message: "输入职员姓名（10字内）",
            trigger: "blur",
          },
          {
            min: 1,
            max: 10,
            message: "输入职员姓名（10字内）",
            trigger: "blur",
          },
        ],
        staffMobile: [
          { required: true, message: "输入手机号码", trigger: "blur" },
          { validator: formValidateMobile, trigger: "blur" },
        ],
        roleId: [{ required: true, message: "请选择角色", trigger: "change" }],
        xcxStaffId: [{ required: true, message: "请选择", trigger: "change" }],
        userAcc: [
          {
            required: true,
            message: "输入登录账号（6-16位字母数字）",
            trigger: "blur",
          },
          {
            min: 6,
            max: 16,
            message: "登录账号（6-16位字母数字）",
            trigger: "blur",
          },
        ],
        staffType: [
          { required: true, message: "请选择职位", trigger: "change" },
        ],
        storeIds: [{ required: true, message: "请选择", trigger: "change" }],
      },
      storeColumns: [{ slotName: "storeName" }, { slotName: "storeAddress" }],
      allotList: [
        { key: "01", value: "店员" },
        { key: "02", value: "店长" },
      ],
      staffTypeList: [
        { key: "04", value: "店员" },
        { key: "03", value: "店长" },
      ],
      allotType: "",
      allotStoreId: "",
      allotOrderScope: "",
      allotOrderStartTime: "",
      allotNoTodoOrderNum: 0,
      isOpenSub: false,
      subStaffId: "",
      dialogSubStaffId: "",
      operationType: "",
      subColumns: [
        { slotName: "isStaffSub" },
        { slotName: "nickName" },
        { slotName: "headImg" },
        { slotName: "staffName" },
        { label: "绑定时间", prop: "bindTime" },
        { slotName: "isSubscribe" },
        { slotName: "operation" },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e7;
        },
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      staffName: "",
      recopyStaffData: {},
      allData: {},
      dlogincodeVisible: false,
      isNeedValid: false,
      entryCodeShow: false,
      generateRow: {},
    };
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams;
    },
  },
  created() {
    if (this.$route.query && this.$route.query.type == "xcx") {
      this.type = "02";
      this.tableColumns = [
        { label: "职员ID", prop: "id" },
        { label: "姓名", prop: "staffName" },
        { slotName: "staffCode" },
        { slotName: "staffType" },
        { slotName: "storeName" },
        { label: "登录手机号", prop: "staffMobile" },
        { label: "添加时间", prop: "createTime" },
        { slotName: "lastActiveTime" },
        { slotName: "lastCreateOrderTime" },
        { slotName: "isSubscribe" },
        { slotName: "canSeeRecycleData" },
        { slotName: "subCount" },
        { slotName: "isEnable" },
        { slotName: "state" },
        { slotName: "operation" },
      ];
    } else {
      this.tableColumns = [
        { label: "姓名", prop: "staffName" },
        { label: "角色", prop: "roleName" },
        { label: "登录账号", prop: "userAcc" },
        { label: "联系电话", prop: "staffMobile" },
        { label: "添加时间", prop: "createTime" },
        { slotName: "isEnable" },
        { slotName: "command" },
        { slotName: "operation" },
      ];
    }

    this.handleCurrentChange();
    this.needValid();
    // this.roleSelectByRole()
  },
  watch: {
    SeachParams(newVal) {
      console.log(newVal);
      this.tableColumns = [];
      this.type = newVal.type;
      if (newVal.type == "01") {
        this.tableColumns = [
          { label: "姓名", prop: "staffName" },
          { label: "角色", prop: "roleName" },
          { label: "登录账号", prop: "userAcc" },
          { label: "联系电话", prop: "staffMobile" },
          { label: "添加时间", prop: "createTime" },
          { slotName: "isEnable" },
          { slotName: "command" },
          { slotName: "operation" },
        ];
      } else {
        this.tableColumns = [
          { label: "职员ID", prop: "id" },
          { label: "姓名", prop: "staffName" },
          { slotName: "staffCode" },
          { slotName: "staffType" },
          { slotName: "storeName" },
          { label: "登录手机号", prop: "staffMobile" },
          { label: "添加时间", prop: "createTime" },
          { slotName: "lastActiveTime" },
          { slotName: "lastCreateOrderTime" },
          { slotName: "isSubscribe" },
          { slotName: "canSeeRecycleData" },
          { slotName: "subCount" },
          { slotName: "isEnable" },
          { slotName: "state" },
          { slotName: "operation" },
        ];
      }
      this.handleCurrentChange();
    },
    allotOrderScope(newVal) {
      if (newVal != "03") {
        this.allotOrderStartTime = "";
      }
      this.getTodoOrderNum();
    },
    allotOrderStartTime() {
      this.getTodoOrderNum();
    },
  },
  methods: {
    // 获取当前商户需不需要动态口令
    needValid() {
      let userInfo = localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user"))
        : {};
      _api.needValid({ account: userInfo.userAcc }).then((res) => {
        this.isNeedValid = res.data;
      });
    },
    // renderHeader(h) {
    //   return (
    //     <div style="display:flex">
    //       <span>是否可查看回收数据</span>
    //       <el-tooltip
    //         class="item"
    //         effect="dark"
    //         content="回收数据指小程序统计页面的回收数量、询价数量、报价数量。"
    //         placement="right"
    //       >
    //         <i
    //           style="display: flex;flex-direction: row;align-items: center;justify-content: center;margin-left: 4px;"
    //           class="el-icon-warning-outline"
    //         ></i>
    //       </el-tooltip>
    //     </div>
    //   );
    // },
    renderHeader2(h) {
      return (
        <div style="display:flex">
          <span>设为收银</span>
          <el-tooltip
            class="item"
            effect="dark"
            content="设为收银可在小程序查看门店团队订单。"
            placement="right"
          >
            <i
              style="display: flex;flex-direction: row;align-items: center;justify-content: center;margin-left: 4px;"
              class="el-icon-warning-outline"
            ></i>
          </el-tooltip>
        </div>
      );
    },
    reSureSubmit() {
      _api
        .saveXcxStaff({
          id: this.staffId,
          staffCode: this.staffForm.staffCode,
          staffMobile: this.staffForm.staffMobile,
          staffName: this.staffForm.staffName,
          staffType: this.staffForm.staffTypes,
          storeIds: this.storeIdsCopy,
          areaId: this.staffForm.areaId,
        })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("操作成功");
            this.dialogVisible = false;
            this.resureshow = false;
          } else {
            this.$message.error(res.msg);
          }
        });
    },

    isStoreCachange(e, row) {
      _api
        .updateIsStoreCashier({ id: row.id, isStoreCashier: e })
        .then((res) => {
          console.log(res, "是否为收银员");
          this.handleCurrentChange(this.pageNum);
        })
        .catch((err) => {
          this.handleCurrentChange(this.pageNum);
        });
    },

    chagestoreIds(e) {
      console.log(e, "门店id值改变");
      if (e.indexOf(undefined) == -1) {
        this.staffForm.storeIds = [];
      } else if (e.indexOf(undefined) != -1) {
        this.storeList.forEach((item) => {
          this.staffForm.storeIds.push(item.key);
        });
        this.staffForm.storeIds = [...new Set(this.staffForm.storeIds)];
      }
    },
    chagestoreIdall(e) {
      console.log(e, "非全选选择");
      if (e.length == this.storeList.length && e.indexOf(undefined) != -1) {
        e.forEach((item, i) => {
          if (item == undefined) {
            this.staffForm.storeIds.splice(i, 1);
          }
        });
      } else if (
        e.length == this.storeList.length &&
        e.indexOf(undefined) == -1
      ) {
        this.staffForm.storeIds.push(undefined);
      }
    },
    removetag() {
      this.chagestoreIdall(this.staffForm.storeIds);
    },

    // 表格切换页面
    handleCurrentChange(val) {
      if (val) {
        this.pageNum = val;
        this.page.pageNum = val;
      } else {
        this.pageNum = 1;
        this.page.pageNum = 1;
      }
      this.StaffEnable.type = this.SeachParams.type || this.type;
      const baseRequest = {
        roleId: this.SeachParams.roleId,
        staffName: this.SeachParams.staffName,
        staffMobile: this.SeachParams.staffMobile,
        staffType: this.SeachParams.staffType,
        storeId: this.SeachParams.storeId,
        type: this.SeachParams.type || this.type,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        isSubscribe: this.SeachParams.isSubscribe,
        doneOrder: this.SeachParams.doneOrder,
        activeNot: this.SeachParams.activeNot,
      };
      this.loading = true;
      _api
        .getWorkerList(baseRequest)
        .then((res) => {
          if (res.code === 1) {
            this.isOpenSub = res.data.isOpenSub;
            this.seachDataList = res.data.page.records;
            this.page.total = res.data.page.total;
            this.page.pageNum = res.data.page.current;
            console.log(res, "{{{{{{{{{{{{{{{{");
            // this.canSeeData = res.data.canSeeData;
            this.$store.commit("tagsView/POST_STAFF", this.seachDataList);
          }
          this.loading = false;
          if (typeof this.SeachParams.disuseLoding === "function") {
            this.SeachParams.disuseLoding();
          }
        })
        .catch(() => {
          if (typeof this.SeachParams.disuseLoding === "function") {
            this.SeachParams.disuseLoding();
          }
        });
    },
    // 表格按钮操作
    handleBtn(row, type) {
      // for(let i = 0;i<this.staffForm.storeIds.length;i++){
      //   if(this.staffForm.storeIds[i] == null){
      //               this.staffForm.storeIds.splice(i,1)
      //             }
      // }

      console.log("表格操作", type, row);
      this.staffId = row.id;
      if (type === "reset") {
        this.dialogVisible = true;
        this.dialogTitle = "重置密码";
        this.dialongDecide = "reset";
      } else if (type === "edit") {
        _api
          .areagetAreaSelect({ inspectorId: this.staffId, scope: "01" })
          .then((res) => {
            this.Regionaldata = res.data;
          });
        this.recopyStaffData = JSON.parse(JSON.stringify(row));
        this.getStoreSelectList({ staffId: row.id, staffType: row.staffType });
        console.log(row.storeIds);
        this.staffForm = {
          staffCode: row.staffCode,
          staffName: row.staffName,
          staffMobile: row.staffMobile,
          roleId: Number(row.roleId),
          userAcc: row.userAcc,
          userPwd: "123456",
          storeIds:
            row.staffType == "01" || row.staffType == "02"
              ? row.storeIds
              : row.storeIds[0],
          staffTypes: row.staffType,
          staffType:
            row.staffType == "01"
              ? "子账号"
              : row.staffType == "02"
              ? "总监"
              : row.staffType == "03"
              ? "店长"
              : "店员",
          xcxStaffId: row.xcxStaffId,
          areaId: row.areaId,
        };

        console.log(this.staffForm, "kkkkkkkkkk");

        this.roleNo = row.roleNo;
        if (row.roleId) {
          _api
            .getXcxStaffSelectByRole({
              roleId: row.roleId,
              xcxStaffId: row.xcxStaffId,
            })
            .then((res) => {
              this.xcxStaffList = res.data;
            });
        }
        this.dialogVisible = true;
        this.dialogTitle = "编辑职员";
        this.dialongDecide = "edit";
        this.canUpdateAcc = row.canUpdateAcc;
      } else if (type === "quit") {
        this.staffName = row.staffName;
        this.quitShow = true;
        this.getStaffAccount(row.id);
      } else if (type === "del") {
        this.dialogVisible = true;
        this.dialogTitle = "删除职员";
        this.dialongDecide = "del";
      } else if (type === "allot") {
        this.getStoreSelectAllot();
        this.getTodoOrderNum();
        this.allotVisible = true;
      } else if (type === "recovery") {
        this.recoveryName = row.staffName;
        this.dialogVisible = true;
        this.dialogTitle = "人员复职";
        this.dialongDecide = "recovery";
      }
    },
    getTodoOrderNum() {
      _api
        .allotNoTodoOrderNum({
          staffId: this.staffId,
          allotOrderScope: this.allotOrderScope,
          allotOrderStartTime: this.allotOrderStartTime,
        })
        .then((res) => {
          this.allotNoTodoOrderNum = res.data;
        });
    },
    allotDialogClosed() {
      this.allotVisible = false;
      this.allotStoreId = "";
      this.allotType = "";
    },
    //启用/禁用账号
    handleSwitch(row) {
      this.dialogVisible = true;
      this.dialogTitle = "启用/禁用账号";
      this.dialongDecide = "switch";
      this.StaffEnable.id = row.id;
      this.StaffEnable.isEnable = row.isEnable;
    },
    getStoreSelectList(params) {
      _api.getStoreSelectList(params).then((res) => {
        this.storeList = res.data;
        console.log(res);
      });
    },
    //弹窗取消
    handleDialogClosed() {
      this.staffForm = {
        staffName: "",
        staffMobile: "",
        roleId: "",
        userAcc: "",
        staffType: "",
        storeIds: "",
      };
      this.dialogVisible = false;
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
      if (this.dialongDecide == "del") {
        this.handleCurrentChange();
      } else {
        this.handleCurrentChange(this.pageNum);
      }
    },
    //弹窗确定
    handleSuccess() {
      console.log(this.staffForm.storeIds, "llllllllllllllllllllllllllll");
      console.log(this.staffForm.storeIds, "88888888888888888888888");
      if (this.dialongDecide == "switch") {
        _api.updateWorkerIsEnable(this.StaffEnable).then((res) => {
          if (res.code === 1) {
            this.$message.success("操作成功");
            this.dialogVisible = false;
          } else {
            this.$message.error(res.msg);
          }
        });
      } else if (this.dialongDecide == "reset") {
        _api.resetStaffPwd({ id: this.staffId }).then((res) => {
          if (res.code === 1) {
            this.$message.success("密码重置成功");
            this.dialogVisible = false;
          } else {
            this.$message.error(res.msg);
          }
        });
      } else if (this.dialongDecide == "del") {
        _api.removeStaff({ id: this.staffId, type: this.type }).then((res) => {
          if (res.code === 1) {
            this.$message.success("操作成功");
            this.dialogVisible = false;
          } else {
            this.$message.error(res.msg);
          }
        });
      }
      if (this.dialongDecide == "edit") {
        let storeIds = this.staffForm.storeIds;
        if (!Array.isArray(this.staffForm.storeIds)) {
          storeIds = [this.staffForm.storeIds];
        } else {
          this.staffForm.storeIds.forEach((item, i) => {
            if (!item) {
              this.staffForm.storeIds.splice(i, 1);
            }
          });
        }
        this.$refs["form"].validate((valid) => {
          if (valid) {
            if (this.dialongDecide == "edit" && this.type == "02") {
              if (
                this.recopyStaffData.staffMobile != this.staffForm.staffMobile
              ) {
                this.storeIdsCopy = storeIds;
                this.resureshow = true;
              } else {
                _api
                  .saveXcxStaff({
                    id: this.staffId,
                    staffCode: this.staffForm.staffCode,
                    staffMobile: this.staffForm.staffMobile,
                    staffName: this.staffForm.staffName,
                    staffType: this.staffForm.staffTypes,
                    storeIds: storeIds,
                    areaId: this.staffForm.areaId,
                  })
                  .then((res) => {
                    if (res.code === 1) {
                      this.$message.success("操作成功");
                      this.dialogVisible = false;
                    } else {
                      this.$message.error(res.msg);
                    }
                  });
              }
            } else if (this.dialongDecide == "edit" && this.type == "01") {
              let params = {
                id: this.staffId,
                staffMobile: this.staffForm.staffMobile,
                staffName: this.staffForm.staffName,
                userAcc: this.staffForm.userAcc,
                xcxStaffId: this.staffForm.xcxStaffId,
                roleId: this.staffForm.roleId,
              };
              _api.savePcStaff(params).then((res) => {
                if (res.code === 1) {
                  this.$message.success("操作成功");
                  this.dialogVisible = false;
                } else {
                  this.$message.error(res.msg);
                }
              });
            }
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } else if (this.dialongDecide == "recovery") {
        _api
          .updateIsQuit({ id: this.staffId, type: this.type, isQuit: false })
          .then((res) => {
            if (res.code === 1) {
              this.$message.success("操作成功");
              this.dialogVisible = false;
            } else {
              this.$message.error(res.msg);
            }
            this.quitButLoading = false;
          })
          .catch(() => {
            this.quitButLoading = false;
          });
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 获取总监门店
    getStoreList(val) {
      if (val) {
        this.storeParams.pageNum = val;
      } else {
        this.storeParams.pageNum = 1;
      }
      const params = {
        inspectorId: this.inspectorId,
        pageNum: this.storeParams.pageNum,
        pageSize: this.storeParams.pageSize,
      };
      this.storeLoading = true;
      _api.StaffManageList(params).then((res) => {
        if (res.code === 1) {
          this.dialogList = res.data.records;
          this.storeParams.total = res.data.total;
          this.storeParams.pageNum = res.data.current;
          this.storeParams.size = res.data.size;
          this.storeLoading = false;
        }
      });
    },
    // 打开总监门店弹窗
    openStore(row) {
      this.inspectorId = row.id;
      this.getStoreList();
      this.storeVisible = true;
    },
    // 打开主从账号管理
    openSubCount(row) {
      this.subVisible = true;
      this.subStaffId = row.id;
      this.getSubStaffs();
    },
    // 关闭总监门店弹窗
    storeClose() {
      this.storeVisible = false;
    },
    getStoreSelectAllot() {
      _api.getStoreSelectAllot({ staffId: this.staffId }).then((res) => {
        if (res.code === 1) {
          this.storeAllotList = res.data;
        }
      });
    },
    allotSuccess() {
      if (!this.allotStoreId) {
        this.$message.error("请选择调拨门店");
        return;
      } else if (!this.allotType) {
        this.$message.error("请选择调拨职位");
        return;
      } else if (!this.allotOrderScope) {
        this.$message.error("请选择是否调拨订单");
        return;
      }
      _api
        .allot({
          allotType: this.allotType,
          staffId: this.staffId,
          storeId: this.allotStoreId,
          allotOrderStartTime: this.allotOrderStartTime,
          allotOrderScope: this.allotOrderScope,
        })
        .then((res) => {
          if (res.code === 1) {
            this.allotOrderScope = "";
            this.allotOrderStartTime = "";
            this.$message.success(res.msg || "调拨成功");
            this.handleCurrentChange(this.pageNum);
            this.allotVisible = false;
          }
        });
    },
    // 主从账号管理弹框关闭
    subDialogClosed() {
      this.subVisible = false;
      this.subDataList = [];
      this.subStaffId = "";
      this.handleCurrentChange(this.pageNum);
    },
    getSubStaffs() {
      console.log(this.subStaffId);
      this.subloading = true;
      _api.getSubStaffs({ staffId: this.subStaffId }).then((res) => {
        if (res.code === 1) {
          this.subDataList = res.data;
        }
        this.subloading = false;
      });
    },
    // 从账号操作
    staffSubHandleBtn(row, type) {
      this.dialogSubStaffId = row.id;
      this.operationType = type;
      this.subStaffShow = true;
    },
    // 从账号操作弹框关闭
    closeSubStaffDialog() {
      this.subStaffShow = false;
    },
    // 从账号操作弹框确认操作
    sureSubOperation() {
      let params = {
        id: this.dialogSubStaffId,
        staffId: this.subStaffId,
        type: this.operationType == "relieve" ? "01" : "02",
      };
      _api.operateSubStaff(params).then((res) => {
        if (res.code === 1) {
          this.$message.success("操作成功");
          this.getSubStaffs();
          this.subStaffShow = false;
        }
      });
    },
    getStaffAccount(staffId) {
      _api.getStaffAccount({ staffId }).then((res) => {
        if (res.code == 1) {
          this.staffBalance = res.data.balance;
          this.canCashOutBalance = res.data.canCashOutBalance;
          this.frozenBalance = res.data.frozenBalance;
        }
      });
    },
    // 确认离职
    quitSubmit() {
      this.quitButLoading = true;
      _api
        .updateIsQuit({ id: this.staffId, type: this.type, isQuit: true })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("操作成功");
            this.quitShow = false;
          } else {
            this.$message.error(res.msg);
          }
          this.quitButLoading = false;
        })
        .catch(() => {
          this.quitButLoading = false;
        });
    },
    quitClosed() {
      this.handleCurrentChange(this.pageNum);
    },
    generateSee(row) {
      _api.queryGoogleCode({ pcStaffId: row.id }).then((res) => {
        if (res.code == 1) {
          this.dlogincodeVisible = true;
          this.allData = res.data;
        }
      });
    },
    generate(row) {
      _api.createGoogleCode({ pcStaffId: row.id }).then((res) => {
        if (res.code == 1) {
          this.dlogincodeVisible = true;
          this.allData = res.data;
        }
      });
    },
    anewGenerate(row) {
      this.entryCodeShow = true;
      this.generateRow = row;
    },
    entryCodeSubmit() {
      this.entryCodeShow = false;
      this.generate(this.generateRow);
    },
    dlogincodeVisibleClose() {
      this.handleCurrentChange(this.pageNum);
    },
    // 下载地址点击复制
    copy(url) {
      const el = document.createElement("textarea");
      el.value = url;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.$message.success("复制成功");
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalTable {
  .edit-dialog {
    /deep/.el-select {
      width: 100%;
    }
    .acc {
      /deep/.el-input {
        width: 330px;
      }
    }
  }
  .step-title {
    display: flex;
    color: #ff687b;
    margin-bottom: 18px;
    align-items: center;
  }
  .select-item {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
  }
}
.imgrender {
  background: url("../../../assets/images/home/tb.png");
  width: 20px;
  height: 20px;
}
.deltop1txt {
  color: red;
  font-size: 14px;
}

.delcen2txt {
  text-align: center;
  margin-top: 20px;
}
.flex {
  display: flex;
  align-items: center;
}
.enable-tip {
  color: #ff8080;
  font-size: 14px;
  margin-bottom: 20px;
  .tip-sure {
    margin-top: 10px;
    color: #333333;
    font-size: 16px;
    text-align: center;
  }
}
.left_fg {
  font-size: 14px;
  text-align: left;
  > p {
    margin-bottom: 10px;
  }
}
.stydata {
  display: inline-block;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.copy {
  color: #0981ff;
  text-decoration: underline;
  cursor: pointer;
  user-select: none;
}
</style>
